import type { Table } from '@wmt/content-blocks'
import { StatsPlayersCellsTeamName } from '#components'
import type { PlayerRoster } from '~/types'

export const defaultColumns: Table.Cell<PlayerRoster.Model>[] = [
  { content: 'Season' },
  { content: 'Team' },
  { content: 'GP', sort: true },
]

export const defaultBodyCells: Table.BodyCell<PlayerRoster.Model>[] = [
  { content: '$get(roster.season.year) + " " + $get(roster.season.srType)' },
  { component: StatsPlayersCellsTeamName },
  { content: '$get(gamesPlayed, 0)' },
]
